import { render, staticRenderFns } from "./QuestionsBase.vue?vue&type=template&id=12016106&"
import script from "./QuestionsBase.vue?vue&type=script&lang=js&"
export * from "./QuestionsBase.vue?vue&type=script&lang=js&"
import style0 from "./QuestionsBase.vue?vue&type=style&index=0&id=12016106&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports